'use client';
import { useState, type FC, type ReactNode } from 'react';

import { ClickableDiv } from '@wwe-portal/ui/components/button';
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipPortal,
  TooltipTrigger,
} from '@wwe-portal/ui/components/tooltip';

interface UserEditProps {
  avatarIcon: ReactNode;
  logoutIcon: ReactNode;
  playerIcon: ReactNode;
  factionIcon: ReactNode;
  streamIcon: ReactNode;
}
export const UserEdit: FC<UserEditProps> = ({
  avatarIcon,
  logoutIcon,
  factionIcon,
  streamIcon,
  playerIcon,
}) => {
  const [open, setOpen] = useState(false);
  return (
    <Tooltip open={open}>
      <TooltipTrigger asChild>
        <ClickableDiv
          className="text-text400 bg-back600 absolute -bottom-1 -right-1 rounded-full p-[5px]"
          onClick={() => {
            setOpen(true);
          }}
        >
          <div className="bg-back200 flex size-7 items-center justify-center rounded-full">
            <svg
              fill="none"
              height="14"
              viewBox="0 0 15 14"
              width="15"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                clipRule="evenodd"
                d="M.442 2.844C.442 1.348 1.654.136 3.149.136h6.943c1.495 0 2.707 1.212 2.707 2.708v2.082c0 .345-.28.625-.624.625-.346 0-.625-.28-.625-.625V2.844c0-.806-.653-1.458-1.458-1.458H3.149c-.805 0-1.458.652-1.458 1.458v6.248c0 .805.653 1.458 1.458 1.458h3.472c.345 0 .624.28.624.625s-.28.624-.624.624H3.149C1.654 11.8.442 10.587.442 9.092V2.844zm2.777 1.388c0-.345.28-.625.625-.625h5.554c.345 0 .624.28.624.625s-.28.625-.624.625H3.844c-.346 0-.625-.28-.625-.625zm8.31 3.233c.515-.516 1.35-.515 1.866 0l1.1 1.1c.516.516.516 1.351 0 1.866l-2.37 2.37c-.247.248-.582.387-.932.387H9.398c-.346 0-.625-.28-.625-.625v-1.795c0-.35.138-.685.386-.933l2.37-2.37zm.982.884c-.028-.028-.071-.027-.097-.001l-2.371 2.37c-.013.014-.02.031-.02.05v1.17h1.17c.018 0 .036-.007.049-.02l2.37-2.37c.028-.028.027-.072 0-.098L12.512 8.35zm-9.292-.646c0-.345.28-.625.625-.625H6.62c.345 0 .624.28.624.625s-.28.625-.624.625H3.844c-.346 0-.625-.28-.625-.625z"
                fill="currentColor"
                fillRule="evenodd"
              />
            </svg>
          </div>
        </ClickableDiv>
      </TooltipTrigger>
      <TooltipPortal>
        <TooltipContent
          className="pointer-events-auto w-[240px] px-5 py-4"
          onPointerDownOutside={() => {
            setOpen(false);
          }}
          side="bottom"
        >
          <div className="text-text500 flex flex-col">
            <div className="flex h-10 items-center gap-3">
              {avatarIcon}
              <span>Change Avatar</span>
            </div>
            <div className="flex h-10 items-center gap-3">
              {playerIcon}
              <span>View Player Profile</span>
            </div>
            <div className="flex h-10 items-center gap-3">
              {factionIcon}
              <span>View Faction Profile</span>
            </div>
            <div className="flex h-10 items-center gap-3">
              {streamIcon}
              <span>Stream Settings</span>
            </div>
            <div className="flex h-10 items-center gap-3">
              {logoutIcon}
              <span>Logout</span>
            </div>
          </div>
          <TooltipArrow />
        </TooltipContent>
      </TooltipPortal>
    </Tooltip>
  );
};
